import cx from "classnames";
import React from "react";

import { BasicButton } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { StreamingEuStep, StreamingEuStepDefaultProps } from "../models";
import {
  StreamingButtonLabels,
  StreamingEuStepTitle,
  StreamingTermsAndConditionsCheckbox1,
  StreamingTermsAndConditionsCheckbox2,
  StreamingTermsAndConditionsCheckbox3,
  StreamingTermsAndConditionsParagraph1,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

export const TermsAndConditions = ({
  navigateToStep,
  storeStreamingData,
}: StreamingEuStepDefaultProps) => {
  const [termsAccepted, setTermsAccepted] = React.useState(false);
  const navigateForward = () => {
    storeStreamingData({ agreesToTermsAndConditions: true });
    navigateToStep(StreamingEuStep.ThankYou);
  };
  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsAccepted(event.target.checked);
  };
  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.TermsAndConditions}</h1>
      <p>{StreamingTermsAndConditionsParagraph1}</p>
      <div className={styles.horizontalCentering}>
        <input type="checkbox" onChange={handleCheckbox} />
        <p>
          {StreamingTermsAndConditionsCheckbox1}
          <a
            href="https://global-networking-idxb-prod-cdn-endpoint.azureedge.net/idxbassetcontainer/DPA_Streaming_Services_EC.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            {StreamingTermsAndConditionsCheckbox2}
          </a>
          {StreamingTermsAndConditionsCheckbox3}
        </p>
      </div>
      <div className={styles.horizontalCentering}>
        <BasicButton
          as={"button"}
          onClick={navigateForward}
          className={cx(commonStyles.primaryButton, styles.buttonPadding)}
          disabled={!termsAccepted}
          textDecorationUnderline={true}
        >
          {StreamingButtonLabels.Submit}
        </BasicButton>
        <StreamingEuCloseButton />
      </div>
    </>
  );
};
